// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home.module.css */

/* Updated Brand Colors */

.container {
  min-height: 100vh;
  background: var(--background);
  font-family: 'Inter', sans-serif;
  padding: 20px;
}

.content {
  max-width: 1200px;
  margin: 0 auto;
}

.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.heroBg {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 0;
}
.heroOverlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.6));
  z-index: 1;
}
.heroImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.heroContent {
  position: relative;
  z-index: 2;
  max-width: 1280px;
  margin: 0 auto;
  padding: 80px 16px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  align-items: center;
}
@media (min-width: 640px) {
  .heroContent {
    padding-left: 24px;
    padding-right: 24px;
  }
}
@media (min-width: 1024px) {
  .heroContent {
    grid-template-columns: 1fr 1fr;
    gap: 48px;
    padding-left: 32px;
    padding-right: 32px;
  }
}
.heroRight {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
@media (min-width: 1024px) {
  .heroRight {
    padding-left: 48px;
  }
}
.heroBadge {
  display: inline-flex;
  align-items: center;
  background: rgba(var(--primary-rgb), 0.08);
  color: var(--primary);
  padding: 8px 16px;
  border-radius: 24px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 24px;
}
.heroTitle {
  font-size: 3rem;
  font-weight: 700;
  color: var(--foreground);
  margin-bottom: 24px;
  line-height: 1.2;
}
@media (min-width: 1024px) {
  .heroTitle {
    font-size: 3.75rem;
  }
}
.heroHighlight {
  background: linear-gradient(45deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.heroDescription {
  font-size: 1.25rem;
  color: var(--muted-foreground);
  margin-bottom: 32px;
  line-height: 1.6;
  max-width: 36rem;
}
.ctaButtons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}
@media (min-width: 640px) {
  .ctaButtons {
    flex-direction: row;
  }
}
.learnMoreButton {
  background: var(--background);
  color: var(--primary);
  border: 2px solid var(--primary);
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
}
.learnMoreButton:hover {
  background: var(--primary);
  color: var(--background);
}
.btn-outline-hero {
  border: 2px solid var(--primary);
  color: var(--primary);
  background: transparent;
  font-weight: 600;
  padding: 1rem 2rem;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 1rem;
}
.btn-outline-hero:hover {
  background: var(--primary);
  color: white;
}
.trustMetrics {
  font-family: 'Inter', sans-serif;
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}
.metric {
  text-align: center;
}
@media (min-width: 1024px) {
  .metric {
    text-align: left;
  }
}
.metricValue {
  font-size: 2rem;
  font-weight: 700;
  color: var(--foreground);
  display: block;
  margin-bottom: 8px;
}
.metricLabel {
  font-size: 1rem;
  font-weight: 500;
  color: var(--muted-foreground);
}
.statsCard, .successCard {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid var(--border);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
.statsCard h3, .successCard h3 {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--foreground);
}
.statsList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.statItem {
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
}
.statItem span:first-child {
  color: var(--muted-foreground);
}
.statItem span:last-child {
  font-weight: 600;
  color: #1a2236;
}
.successCard p {
  font-size: 0.875rem;
  color: var(--muted-foreground);
  margin-bottom: 12px;
}
.successCard strong {
  color: var(--foreground);
}
.successCard span {
  color: var(--success);
  font-weight: 600;
}
.space-y-3 > * + * {
  margin-top: 12px;
}
.space-y-8 > * + * {
  margin-top: 2rem;
}

/* How It Works */
.howItWorks {
  background: var(--muted);
  padding: 80px 0;
}

.step {
  position: relative;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 32px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.step:hover {
  border-color: rgba(var(--primary-rgb), 0.18);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}

.step .absolute {
  position: absolute;
  top: -16px;
  left: -16px;
  width: 40px;
  height: 40px;
  background: linear-gradient(45deg, var(--primary), var(--secondary));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s;
}

.step:hover .absolute {
  transform: scale(1.1);
}

.step .w-16 {
  width: 64px;
  height: 64px;
  background: linear-gradient(45deg, rgba(var(--primary-rgb), 0.08), rgba(var(--secondary-rgb), 0.08));
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  transition: all 0.3s;
}

.step:hover .w-16 {
  background: linear-gradient(45deg, rgba(var(--primary-rgb), 0.16), rgba(var(--secondary-rgb), 0.16));
}

.step .w-8 {
  width: 32px;
  height: 32px;
  color: var(--primary);
  transition: transform 0.3s;
}

.step:hover .w-8 {
  transform: scale(1.1);
}

.stepTitle {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--foreground);
  margin-bottom: 16px;
  text-align: center;
}

.stepDesc {
  color: var(--muted-foreground);
  line-height: 1.6;
  text-align: center;
}

.trustBadge {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--muted-foreground);
  font-size: 0.9rem;
}

.trustBadge .w-6 {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.75rem;
  font-weight: bold;
}

.bg-success {
  background: var(--success);
}

.bg-info {
  background: var(--secondary);
}

.bg-warning {
  background: #f59e0b;
}

/* Featured Projects */
.featuredProjects {
  background: var(--background);
  padding: 80px 0;
}

.projectCard {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.projectCard:hover {
  transform: translateY(-4px);
}

.projectImage {
  width: 100%;
  height: 192px;
  object-fit: cover;
  border-radius: 12px;
  transition: transform 0.3s;
}

.badge {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  color: #1a2236;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
}

.badge.active {
  background: var(--success);
  color: white;
}

.badge.funding {
  background: var(--secondary);
  color: white;
}

.badge.sold {
  background: var(--muted-foreground);
  color: white;
}

.projectTitle {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a2236;
  margin-bottom: 8px;
}

.progress-funded {
  width: 100%;
  height: 0.5rem;
  background: var(--muted);
  border-radius: 9999px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(to right, var(--primary), var(--secondary));
  border-radius: 9999px;
  transition: all 0.5s;
}

.viewDetailsButton {
  background: white;
  color: #1a2236;
  padding: 12px 24px;
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.viewDetailsButton:hover {
  background: var(--muted);
  border-color: var(--border);
}

/* Basic Layout */
.homeContainer {
  font-family: 'Inter', sans-serif;
}

.mainHeader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  z-index: 1000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.headerContainer {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logoImage {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 800;
  font-size: 20px;
}

.logoText {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--foreground);
}

.navMenu {
  display: flex;
  align-items: center;
  gap: 24px;
}

.navLink {
  color: var(--foreground);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.navLink:hover {
  color: var(--primary);
}

.navButton {
  background: linear-gradient(45deg, var(--primary), var(--secondary));
  color: white;
  padding: 10px 20px;
  border-radius: 24px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: transform 0.2s;
}

.navButton:hover {
  transform: translateY(-2px);
}

.sectionTitle {
  font-size: 2.25rem;
  font-weight: 700;
  color: #1a2236;
  margin-bottom: 16px;
  text-align: center;
}

.text-xl {
  font-size: 1.25rem;
}

.text-muted-foreground {
  color: var(--muted-foreground);
}

.text-primary {
  color: var(--primary);
}

.max-w-2xl {
  max-width: 672px;
}

.max-w-3xl {
  max-width: 768px;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.mb-16 {
  margin-bottom: 64px;
}

.mb-12 {
  margin-bottom: 48px;
}

.mb-8 {
  margin-bottom: 32px;
}

.mb-4 {
  margin-bottom: 16px;
}

.mb-3 {
  margin-bottom: 12px;
}

.mb-2 {
  margin-bottom: 8px;
}

.mt-16 {
  margin-top: 64px;
}

.mt-20 {
  margin-top: 80px;
}

.py-20 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.px-4 {
  padding-left: 16px;
  padding-right: 16px;
}

.sm\\:px-6 {
  padding-left: 24px;
  padding-right: 24px;
}

.lg\\:px-8 {
  padding-left: 32px;
  padding-right: 32px;
}

.max-w-7xl {
  max-width: 1280px;
}

.text-center {
  text-align: center;
}

.grid {
  display: grid;
}

.md\\:grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.md\\:grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.lg\\:grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.lg\\:grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

.gap-8 {
  gap: 32px;
}

.gap-4 {
  gap: 16px;
}

.gap-3 {
  gap: 12px;
}

.space-y-4 > * + * {
  margin-top: 16px;
}

.space-y-2 > * + * {
  margin-top: 8px;
}

.relative {
  position: relative;
}

.overflow-hidden {
  overflow: hidden;
}

.rounded-xl {
  border-radius: 12px;
}

.rounded-2xl {
  border-radius: 16px;
}

.rounded-full {
  border-radius: 50%;
}

.flex {
  display: flex;
}

.flex-1 {
  flex: 1 1;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.w-4 {
  width: 16px;
}

.h-4 {
  height: 16px;
}

.mr-1 {
  margin-right: 4px;
}

.text-sm {
  font-size: 0.875rem;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.text-foreground {
  color: #1a2236;
}

.text-success {
  color: #10b981;
}

.border-t {
  border-top: 1px solid #e5e7eb;
}

.border-border {
  border-color: #e5e7eb;
}

.py-3 {
  padding-top: 12px;
  padding-bottom: 12px;
}

.pt-2 {
  padding-top: 8px;
}

.text-3xl {
  font-size: 1.875rem;
}

.footer {
  background: #1a2236;
  color: white;
  padding: 40px 0;
  text-align: center;
}

.footerLinks {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 16px;
}

.footerLink {
  color: #e0e0e0;
  text-decoration: none;
  transition: color 0.2s;
}

.footerLink:hover {
  color: #ff6b6b;
}

.footerText {
  color: #6b7280;
}

/* Footer Styles */
footer {
  background: rgba(0, 0, 0, 0.05);
  border-top: 1px solid #e5e7eb;
}

footer .space-y-4 > * + * {
  margin-top: 1rem;
}

footer .space-y-3 > * + * {
  margin-top: 0.75rem;
}

footer .space-y-2 > * + * {
  margin-top: 0.5rem;
}

footer .flex {
  display: flex;
}

footer .items-center {
  align-items: center;
}

footer .space-x-3 > * + * {
  margin-left: 0.75rem;
}

footer .w-10 {
  width: 2.5rem;
}

footer .h-10 {
  height: 2.5rem;
}

footer .bg-gradient-to-br {
  background: linear-gradient(to bottom right, var(--primary), var(--secondary));
}

footer .rounded-xl {
  border-radius: 0.75rem;
}

footer .text-white {
  color: white;
}

footer .text-xl {
  font-size: 1.25rem;
}

footer .font-bold {
  font-weight: 700;
}

footer .text-foreground {
  color: #1a2236;
}

footer .text-muted-foreground {
  color: #6b7280;
}

footer .w-4 {
  width: 1rem;
}

footer .h-4 {
  height: 1rem;
}

footer .mr-2 {
  margin-right: 0.5rem;
}

footer .text-sm {
  font-size: 0.875rem;
}

footer .font-semibold {
  font-weight: 600;
}

footer .mb-4 {
  margin-bottom: 1rem;
}

footer .hover\\:text-primary:hover {
  color: var(--primary);
}

footer .transition-colors {
  transition: color 0.2s;
}

footer .border-t {
  border-top: 1px solid #e5e7eb;
}

footer .mt-12 {
  margin-top: 3rem;
}

footer .pt-8 {
  padding-top: 2rem;
}

footer .flex-col {
  flex-direction: column;
}

footer .md\\:flex-row {
  flex-direction: row;
}

footer .justify-between {
  justify-content: space-between;
}

footer .mb-4 {
  margin-bottom: 1rem;
}

footer .md\\:mb-0 {
  margin-bottom: 0;
}

footer .mr-1 {
  margin-right: 0.25rem;
}

footer .mt-6 {
  margin-top: 1.5rem;
}

footer .text-xs {
  font-size: 0.75rem;
}

footer .bg-muted\\/50 {
  background: rgba(0, 0, 0, 0.05);
}

footer .p-4 {
  padding: 1rem;
}

footer .rounded-lg {
  border-radius: 0.5rem;
}

footer .grid {
  display: grid;
}

footer .md\\:grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

footer .gap-8 {
  gap: 2rem;
}

footer .py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB,yBAAyB;;AAEzB;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,oHAAoH;EACpH,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,oEAAoE;EACpE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oEAAoE;EACpE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oGAAoG;EACpG,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uEAAuE;EACvE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qEAAqE;EACrE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oEAAoE;EACpE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":["/* Home.module.css */\n\n/* Updated Brand Colors */\n\n.container {\n  min-height: 100vh;\n  background: var(--background);\n  font-family: 'Inter', sans-serif;\n  padding: 20px;\n}\n\n.content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.hero {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n.heroBg {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  z-index: 0;\n}\n.heroOverlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to right, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.6));\n  z-index: 1;\n}\n.heroImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.heroContent {\n  position: relative;\n  z-index: 2;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 80px 16px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 48px;\n  align-items: center;\n}\n@media (min-width: 640px) {\n  .heroContent {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n}\n@media (min-width: 1024px) {\n  .heroContent {\n    grid-template-columns: 1fr 1fr;\n    gap: 48px;\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n}\n.heroRight {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n@media (min-width: 1024px) {\n  .heroRight {\n    padding-left: 48px;\n  }\n}\n.heroBadge {\n  display: inline-flex;\n  align-items: center;\n  background: rgba(var(--primary-rgb), 0.08);\n  color: var(--primary);\n  padding: 8px 16px;\n  border-radius: 24px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-bottom: 24px;\n}\n.heroTitle {\n  font-size: 3rem;\n  font-weight: 700;\n  color: var(--foreground);\n  margin-bottom: 24px;\n  line-height: 1.2;\n}\n@media (min-width: 1024px) {\n  .heroTitle {\n    font-size: 3.75rem;\n  }\n}\n.heroHighlight {\n  background: linear-gradient(45deg, var(--primary), var(--secondary));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n.heroDescription {\n  font-size: 1.25rem;\n  color: var(--muted-foreground);\n  margin-bottom: 32px;\n  line-height: 1.6;\n  max-width: 36rem;\n}\n.ctaButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n@media (min-width: 640px) {\n  .ctaButtons {\n    flex-direction: row;\n  }\n}\n.learnMoreButton {\n  background: var(--background);\n  color: var(--primary);\n  border: 2px solid var(--primary);\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition: all 0.3s;\n  text-decoration: none;\n}\n.learnMoreButton:hover {\n  background: var(--primary);\n  color: var(--background);\n}\n.btn-outline-hero {\n  border: 2px solid var(--primary);\n  color: var(--primary);\n  background: transparent;\n  font-weight: 600;\n  padding: 1rem 2rem;\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-size: 1rem;\n}\n.btn-outline-hero:hover {\n  background: var(--primary);\n  color: white;\n}\n.trustMetrics {\n  font-family: 'Inter', sans-serif;\n  display: flex;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n.metric {\n  text-align: center;\n}\n@media (min-width: 1024px) {\n  .metric {\n    text-align: left;\n  }\n}\n.metricValue {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--foreground);\n  display: block;\n  margin-bottom: 8px;\n}\n.metricLabel {\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--muted-foreground);\n}\n.statsCard, .successCard {\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid var(--border);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n.statsCard h3, .successCard h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: var(--foreground);\n}\n.statsList {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.statItem {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.875rem;\n}\n.statItem span:first-child {\n  color: var(--muted-foreground);\n}\n.statItem span:last-child {\n  font-weight: 600;\n  color: #1a2236;\n}\n.successCard p {\n  font-size: 0.875rem;\n  color: var(--muted-foreground);\n  margin-bottom: 12px;\n}\n.successCard strong {\n  color: var(--foreground);\n}\n.successCard span {\n  color: var(--success);\n  font-weight: 600;\n}\n.space-y-3 > * + * {\n  margin-top: 12px;\n}\n.space-y-8 > * + * {\n  margin-top: 2rem;\n}\n\n/* How It Works */\n.howItWorks {\n  background: var(--muted);\n  padding: 80px 0;\n}\n\n.step {\n  position: relative;\n  background: rgba(255, 255, 255, 0.5);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 32px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  transition: all 0.3s;\n}\n\n.step:hover {\n  border-color: rgba(var(--primary-rgb), 0.18);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  transform: translateY(-4px);\n}\n\n.step .absolute {\n  position: absolute;\n  top: -16px;\n  left: -16px;\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(45deg, var(--primary), var(--secondary));\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n  transition: transform 0.3s;\n}\n\n.step:hover .absolute {\n  transform: scale(1.1);\n}\n\n.step .w-16 {\n  width: 64px;\n  height: 64px;\n  background: linear-gradient(45deg, rgba(var(--primary-rgb), 0.08), rgba(var(--secondary-rgb), 0.08));\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px;\n  transition: all 0.3s;\n}\n\n.step:hover .w-16 {\n  background: linear-gradient(45deg, rgba(var(--primary-rgb), 0.16), rgba(var(--secondary-rgb), 0.16));\n}\n\n.step .w-8 {\n  width: 32px;\n  height: 32px;\n  color: var(--primary);\n  transition: transform 0.3s;\n}\n\n.step:hover .w-8 {\n  transform: scale(1.1);\n}\n\n.stepTitle {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--foreground);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.stepDesc {\n  color: var(--muted-foreground);\n  line-height: 1.6;\n  text-align: center;\n}\n\n.trustBadge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--muted-foreground);\n  font-size: 0.9rem;\n}\n\n.trustBadge .w-6 {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n\n.bg-success {\n  background: var(--success);\n}\n\n.bg-info {\n  background: var(--secondary);\n}\n\n.bg-warning {\n  background: #f59e0b;\n}\n\n/* Featured Projects */\n.featuredProjects {\n  background: var(--background);\n  padding: 80px 0;\n}\n\n.projectCard {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s;\n}\n\n.projectCard:hover {\n  transform: translateY(-4px);\n}\n\n.projectImage {\n  width: 100%;\n  height: 192px;\n  object-fit: cover;\n  border-radius: 12px;\n  transition: transform 0.3s;\n}\n\n.badge {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n  color: #1a2236;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.badge.active {\n  background: var(--success);\n  color: white;\n}\n\n.badge.funding {\n  background: var(--secondary);\n  color: white;\n}\n\n.badge.sold {\n  background: var(--muted-foreground);\n  color: white;\n}\n\n.projectTitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1a2236;\n  margin-bottom: 8px;\n}\n\n.progress-funded {\n  width: 100%;\n  height: 0.5rem;\n  background: var(--muted);\n  border-radius: 9999px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(to right, var(--primary), var(--secondary));\n  border-radius: 9999px;\n  transition: all 0.5s;\n}\n\n.viewDetailsButton {\n  background: white;\n  color: #1a2236;\n  padding: 12px 24px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.viewDetailsButton:hover {\n  background: var(--muted);\n  border-color: var(--border);\n}\n\n/* Basic Layout */\n.homeContainer {\n  font-family: 'Inter', sans-serif;\n}\n\n.mainHeader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  z-index: 1000;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.headerContainer {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 80px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.logoImage {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--primary), var(--secondary));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 800;\n  font-size: 20px;\n}\n\n.logoText {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--foreground);\n}\n\n.navMenu {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.navLink {\n  color: var(--foreground);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.navLink:hover {\n  color: var(--primary);\n}\n\n.navButton {\n  background: linear-gradient(45deg, var(--primary), var(--secondary));\n  color: white;\n  padding: 10px 20px;\n  border-radius: 24px;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  transition: transform 0.2s;\n}\n\n.navButton:hover {\n  transform: translateY(-2px);\n}\n\n.sectionTitle {\n  font-size: 2.25rem;\n  font-weight: 700;\n  color: #1a2236;\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n}\n\n.text-muted-foreground {\n  color: var(--muted-foreground);\n}\n\n.text-primary {\n  color: var(--primary);\n}\n\n.max-w-2xl {\n  max-width: 672px;\n}\n\n.max-w-3xl {\n  max-width: 768px;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.mb-16 {\n  margin-bottom: 64px;\n}\n\n.mb-12 {\n  margin-bottom: 48px;\n}\n\n.mb-8 {\n  margin-bottom: 32px;\n}\n\n.mb-4 {\n  margin-bottom: 16px;\n}\n\n.mb-3 {\n  margin-bottom: 12px;\n}\n\n.mb-2 {\n  margin-bottom: 8px;\n}\n\n.mt-16 {\n  margin-top: 64px;\n}\n\n.mt-20 {\n  margin-top: 80px;\n}\n\n.py-20 {\n  padding-top: 80px;\n  padding-bottom: 80px;\n}\n\n.px-4 {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.sm\\:px-6 {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.lg\\:px-8 {\n  padding-left: 32px;\n  padding-right: 32px;\n}\n\n.max-w-7xl {\n  max-width: 1280px;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.grid {\n  display: grid;\n}\n\n.md\\:grid-cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.md\\:grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.lg\\:grid-cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.lg\\:grid-cols-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.gap-8 {\n  gap: 32px;\n}\n\n.gap-4 {\n  gap: 16px;\n}\n\n.gap-3 {\n  gap: 12px;\n}\n\n.space-y-4 > * + * {\n  margin-top: 16px;\n}\n\n.space-y-2 > * + * {\n  margin-top: 8px;\n}\n\n.relative {\n  position: relative;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.rounded-xl {\n  border-radius: 12px;\n}\n\n.rounded-2xl {\n  border-radius: 16px;\n}\n\n.rounded-full {\n  border-radius: 50%;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.w-4 {\n  width: 16px;\n}\n\n.h-4 {\n  height: 16px;\n}\n\n.mr-1 {\n  margin-right: 4px;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.text-foreground {\n  color: #1a2236;\n}\n\n.text-success {\n  color: #10b981;\n}\n\n.border-t {\n  border-top: 1px solid #e5e7eb;\n}\n\n.border-border {\n  border-color: #e5e7eb;\n}\n\n.py-3 {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.pt-2 {\n  padding-top: 8px;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n}\n\n.footer {\n  background: #1a2236;\n  color: white;\n  padding: 40px 0;\n  text-align: center;\n}\n\n.footerLinks {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  margin-bottom: 16px;\n}\n\n.footerLink {\n  color: #e0e0e0;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.footerLink:hover {\n  color: #ff6b6b;\n}\n\n.footerText {\n  color: #6b7280;\n}\n\n/* Footer Styles */\nfooter {\n  background: rgba(0, 0, 0, 0.05);\n  border-top: 1px solid #e5e7eb;\n}\n\nfooter .space-y-4 > * + * {\n  margin-top: 1rem;\n}\n\nfooter .space-y-3 > * + * {\n  margin-top: 0.75rem;\n}\n\nfooter .space-y-2 > * + * {\n  margin-top: 0.5rem;\n}\n\nfooter .flex {\n  display: flex;\n}\n\nfooter .items-center {\n  align-items: center;\n}\n\nfooter .space-x-3 > * + * {\n  margin-left: 0.75rem;\n}\n\nfooter .w-10 {\n  width: 2.5rem;\n}\n\nfooter .h-10 {\n  height: 2.5rem;\n}\n\nfooter .bg-gradient-to-br {\n  background: linear-gradient(to bottom right, var(--primary), var(--secondary));\n}\n\nfooter .rounded-xl {\n  border-radius: 0.75rem;\n}\n\nfooter .text-white {\n  color: white;\n}\n\nfooter .text-xl {\n  font-size: 1.25rem;\n}\n\nfooter .font-bold {\n  font-weight: 700;\n}\n\nfooter .text-foreground {\n  color: #1a2236;\n}\n\nfooter .text-muted-foreground {\n  color: #6b7280;\n}\n\nfooter .w-4 {\n  width: 1rem;\n}\n\nfooter .h-4 {\n  height: 1rem;\n}\n\nfooter .mr-2 {\n  margin-right: 0.5rem;\n}\n\nfooter .text-sm {\n  font-size: 0.875rem;\n}\n\nfooter .font-semibold {\n  font-weight: 600;\n}\n\nfooter .mb-4 {\n  margin-bottom: 1rem;\n}\n\nfooter .hover\\:text-primary:hover {\n  color: var(--primary);\n}\n\nfooter .transition-colors {\n  transition: color 0.2s;\n}\n\nfooter .border-t {\n  border-top: 1px solid #e5e7eb;\n}\n\nfooter .mt-12 {\n  margin-top: 3rem;\n}\n\nfooter .pt-8 {\n  padding-top: 2rem;\n}\n\nfooter .flex-col {\n  flex-direction: column;\n}\n\nfooter .md\\:flex-row {\n  flex-direction: row;\n}\n\nfooter .justify-between {\n  justify-content: space-between;\n}\n\nfooter .mb-4 {\n  margin-bottom: 1rem;\n}\n\nfooter .md\\:mb-0 {\n  margin-bottom: 0;\n}\n\nfooter .mr-1 {\n  margin-right: 0.25rem;\n}\n\nfooter .mt-6 {\n  margin-top: 1.5rem;\n}\n\nfooter .text-xs {\n  font-size: 0.75rem;\n}\n\nfooter .bg-muted\\/50 {\n  background: rgba(0, 0, 0, 0.05);\n}\n\nfooter .p-4 {\n  padding: 1rem;\n}\n\nfooter .rounded-lg {\n  border-radius: 0.5rem;\n}\n\nfooter .grid {\n  display: grid;\n}\n\nfooter .md\\:grid-cols-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\nfooter .gap-8 {\n  gap: 2rem;\n}\n\nfooter .py-16 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
